export default __webpack_public_path__ + "static/instagram-6130efa332b132a7be2e8a2da8f590f1.svg";